import { useContext, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

import { PageEndContext } from './pageEndContext'

/**
 * Renders its children at the END of the page (R73, owner instruction
 * 2026-10-01): research notes belong after everything a page shows, and a
 * shared body such as `DailyStatusBody` cannot know what its host renders
 * after it (Recording detail's journal form, for one). Inside the shell the
 * children are portalled into the shell's page-end element; outside it they
 * render where they are. The React tree, and with it context and the
 * components that render them, does not move.
 */
export function PageEnd({ children }: { children: ReactNode }) {
  const el = useContext(PageEndContext)
  return el === null ? <>{children}</> : createPortal(children, el)
}
